import React, { useState } from 'react';
import styles from '../../css/components/overlays/cookieOverlayExtendedBottom.css';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CTAButton from '../buttons/CTAButton';

function CookieOverlayExtendedBottom({
	onCTAButtonClick,
	privacyHref,
	imprintHref,
	onRejectCookies,
}) {
	const [showSettings, setShowSettings] = useState(false);
	const [showMarketing, setShowMarketing] = useState(false);
	const [showNecessary, setShowNecessary] = useState(false);
	const [showFunctional, setShowFunctional] = useState(false);
	const [acceptMarketing, setAcceptMarketing] = useState(false);

	const { t } = useTranslation('translation');

	const googleLink = 'https://business.safety.google/privacy';

	return (
		<div className={styles.overlayBackground}>
			<div className={styles.overlayWrapper}>
				<div className={styles.settingsContent}>
					<h1>{t('cookieOverlay.extended.title')}</h1>
					<p>
						{t('cookieOverlay.extended.main')}
						<a
							target='_blank'
							href={googleLink}
							rel='noreferrer'
						>
							{ googleLink }
						</a>
					</p>
					{showSettings && (
						<ul>
							<li>
								<div className={styles.cookiesListElement}>
									<a
										onClick={() => {
											setShowMarketing(!showMarketing);
										}}>
										<div className={`${styles.cookieNotificationSettingsElement} ${showMarketing && styles.cookieNotificationSettingsElementActive}`}>
											{t('cookieOverlay.extended.settings.marketing.label')}
										</div>
									</a>
									<input
										type="checkbox"
										className={styles.cookiesCheckbox}
										onChange={() => {
											setAcceptMarketing(!acceptMarketing);
										}}
										checked={acceptMarketing}
									/>
								</div>
								{showMarketing && (
									<p className={styles.elementText}>
										{t('cookieOverlay.extended.settings.marketing.main')}
									</p>
								)}
							</li>
							<li>
								<div className={styles.cookiesListElement}>
									<a
										onClick={() => {
											setShowNecessary(!showNecessary);
										}}>
										<div className={`${styles.cookieNotificationSettingsElement} ${showNecessary && styles.cookieNotificationSettingsElementActive}`}>
											{t('cookieOverlay.extended.settings.neccesary.label')}
										</div>
									</a>
								</div>
								{showNecessary && (
									<p className={styles.elementText}>
										{t('cookieOverlay.extended.settings.neccesary.main')}
									</p>
								)}
							</li>
							<li>
								<div className={styles.cookiesListElement}>
									<a
										onClick={() => {
											setShowFunctional(!showFunctional);
										}}>
										<div className={`${styles.cookieNotificationSettingsElement} ${showFunctional && styles.cookieNotificationSettingsElementActive}`}>
											{t('cookieOverlay.extended.settings.functional.label')}
										</div>
									</a>
								</div>
								{showFunctional && (
									<p className={styles.elementText}>
										{t('cookieOverlay.extended.settings.functional.main')}
									</p>
								)}
							</li>
						</ul>
					)}
				</div>
				<div className={styles.buttonWrapper}>
					{!showSettings && (
						<CTAButton
							onButtonClick={onCTAButtonClick}
							buttonLabel={t('cookieOverlay.extended.cta1')}
							extraClassName="cookieOverlayExtendedBottom"
							buttonId="pop-up_cookie_button_accept"
						/>
					)}
					{showSettings && (
						<CTAButton
							onButtonClick={onCTAButtonClick}
							buttonLabel={t('cookieOverlay.extended.cta2')}
							extraClassName="cookieOverlayExtendedBottom"
							buttonId="pop-up_cookie_button_accept"
						/>
					)}
					<CTAButton
						onButtonClick={onRejectCookies}
						buttonLabel={t('cookieOverlay.extended.reject')}
						extraClassName="cookieOverlayExtendedBottom"
						buttonId="pop-up_cookie_button_decline"
					/>
					<p className={styles.settingsButton}>
						{!showSettings && (
							<a
								onClick={() => {
									setShowSettings(!showSettings);
								}}
								className={styles.otherOption}
								id="pop-up_cookie_text_settings"
							>
								{t('cookieOverlay.extended.settingsButton')}
							</a>
						)}
						{showSettings && (

							<a
								onClick={acceptMarketing ? onCTAButtonClick : onRejectCookies}
								className={styles.otherOption}
								id="pop-up_cookie_text_save"
							>
								{t('cookieOverlay.extended.saveButton')}
							</a>
						)}
					</p>
				</div>

				<div className={styles.otherOptionsWrapper}>
					<p>
						<a
							href={privacyHref}
							target="_blank"
							rel="noopener noreferrer"
							className={styles.otherOptionsLink}
							id="pop-up_cookie_text_privacy-policy"
						>
							{t('cookieOverlay.extended.privacyPolicy')}
						</a>
						&nbsp;|&nbsp;
						<a
							href={imprintHref}
							target="_blank"
							rel="noopener noreferrer"
							className={styles.otherOptionsLink}
							id="pop-up_cookie_text_legal-notice"
						>
							{t('cookieOverlay.extended.legalNotice')}
						</a>
					</p>
				</div>
			</div>
		</div>
	);
}

export default CookieOverlayExtendedBottom;

CookieOverlayExtendedBottom.propTypes = {
	onCTAButtonClick: PropTypes.func.isRequired,
	privacyHref: PropTypes.string.isRequired,
	imprintHref: PropTypes.string.isRequired,
	onRejectCookies: PropTypes.func.isRequired,
};
